// App Version - wird bei jeder Änderung erhöht
export const APP_VERSION = "1.341";
